import { createContext, useEffect, useState } from "react";
import { IConfigState } from "../common/constants/app.dto";
import { configState } from "./states/configState";
import * as API from "../common/apis/public.api";

interface configContextProps {
    configData: IConfigState;
}

export const configContext = createContext({} as configContextProps);

export const ConfigContextProvider = (props: any) => {

    const [config, setConfig] = useState({...configState});

    const fetchConfigurationData = () => {
        Promise.allSettled([

            API.getGraduations(),
            API.getUniversities(),
            API.getAreas(),
            API.getSectors(),
            API.getSpecialties(),
            API.getPositions(),
            API.getBeneficials(),
            API.getDepartments(1),

        ]).then((data: any) => {

            setConfig({
                grades: data[0]?.value ?? [],
                universities: data[1]?.value ?? [],
                areas: data[2]?.value ?? [],
                sectors: data[3]?.value ?? [],
                professions: data[4]?.value ?? [],
                positions: data[5]?.value ?? [],
                benefits: data[6]?.value ?? [],
                geoDepartments: data[7]?.value ?? [],
            })
        })
    }
    
    useEffect(() => {
        fetchConfigurationData();
    }, []);

    return(
        <configContext.Provider value={{configData: config}}>
            {props.children}
        </configContext.Provider>
    )
}